import React, { useState } from 'react'
import { SelectBox } from '@tecuity/granite-ui'
import './CustomCorrespondenceOptions.scss'
import { useDispatch } from 'react-redux'
import * as api from 'requests'
import { SET_SETTINGS_LIST, SET_OPTIONAL_DATA } from '../../SettingsReducer'
import { useSelector, shallowEqual } from 'react-redux'
import { Spinner } from 'components/Loaders/Loaders'

const BusinessRecordSubTypeToRecordTypeOptions = () => {
  const dispatch = useDispatch()
  const { optionalData } = useSelector((state) => state.settings, shallowEqual)

  const [recordTypeOptions, setRecordTypeOptions] = useState([])
  const [recordType, setRecordType] = useState(optionalData.recordType || 0)
  const [loading, setLoading] = useState(false)
  const [recordTypeDisabled, setRecordTypeDisabled] = useState(false)

  React.useEffect(() => {
    setLoading(true)
    api.GET_BUSINESS_RECORD_SUB_TYPE_XREFS_BY_RECORD_TYPE(
      recordType,
      (res) => {
        dispatch({
          type: SET_SETTINGS_LIST,
          settingsList: res,
        })
        dispatch({ type: SET_OPTIONAL_DATA, optionalData: { recordType } })
        setLoading(false)
      },
      (err) => {
        console.error('retrieving', err)
        setLoading(false)
      }
    )
  }, [recordType])

  const getRecordTypeOptions = () => {
    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      'Business',
      'RecordType',
      (res) => {
        setRecordTypeOptions([
          ...res.map((t) => ({
            value: t.Id,
            label: t.Name,
          })),
        ])
        setRecordType(1)
      },
      (err) => {
        setRecordTypeDisabled(true)
        setRecordTypeOptions([{ label: 'Error loading', value: '0' }])
        console.error(err.message)
      }
    )
  }

  React.useEffect(() => {
    getRecordTypeOptions()
  }, [])

  return (
    <div className="custom-correspondence-options">
      <SelectBox
        label="Business Record Type"
        noPlaceholder
        value={recordType}
        onChange={(val) => {
          setRecordType(val)
        }}
        disabled={recordTypeDisabled}
        options={recordTypeOptions}
      />
      {loading && (
        <div className="type-loader">
          <Spinner size="small" themeColor="dark-neutral" />
        </div>
      )}
    </div>
  )
}

export default BusinessRecordSubTypeToRecordTypeOptions
